import type { ReactNode } from 'react';
import { Modal } from '@/components/ui/Modal/Modal';
import { Button } from '@/components/ui/Button/Button';
import './EmailModalShell.css';

interface EmailModalShellProps {
  open: boolean;
  onClose: () => void;
  title: string;
  fieldsSlot: ReactNode;
  /** Кнопка выбора файлов для ссылок в письме (рядом с предпросмотром) */
  attachFilesSlot?: ReactNode;
  /** Открыть отдельное окно с HTML-черновиком письма */
  onOpenPreview: () => void;
  previewTriggerDisabled?: boolean;
  onSaveWithoutEmail: () => void;
  saveWithoutEmailDisabled?: boolean;
  onSaveWithEmail: () => void;
  saveWithEmailDisabled?: boolean;
  isSubmitting?: boolean;
  submittingWithoutEmail?: boolean;
  submittingWithEmail?: boolean;
}

export function EmailModalShell({
  open,
  onClose,
  title,
  fieldsSlot,
  attachFilesSlot,
  onOpenPreview,
  previewTriggerDisabled,
  onSaveWithoutEmail,
  saveWithoutEmailDisabled,
  onSaveWithEmail,
  saveWithEmailDisabled,
  isSubmitting,
  submittingWithoutEmail,
  submittingWithEmail,
}: EmailModalShellProps) {
  return (
    <Modal open={open} onClose={onClose} title={title} size="ml" headerVariant="island" className="email-modal-shell">
      <div className="email-modal-shell__inner">
        {fieldsSlot}

        <div
          className={
            attachFilesSlot
              ? 'email-modal-shell__preview-trigger email-modal-shell__preview-trigger--split'
              : 'email-modal-shell__preview-trigger'
          }
        >
          {attachFilesSlot}
          <Button
            fullWidth
            variant="outlined"
            type="button"
            onClick={onOpenPreview}
            disabled={previewTriggerDisabled || isSubmitting}
          >
            Предпросмотр письма
          </Button>
        </div>

        <div className="email-modal-shell__actions">
          <Button
            fullWidth
            variant="outlined"
            type="button"
            onClick={onSaveWithoutEmail}
            disabled={saveWithoutEmailDisabled || isSubmitting}
          >
            {submittingWithoutEmail ? 'Сохранение…' : 'Сохранить без отправки'}
          </Button>
          <Button
            fullWidth
            variant="primary"
            type="button"
            onClick={onSaveWithEmail}
            disabled={saveWithEmailDisabled || isSubmitting}
          >
            {submittingWithEmail ? 'Сохранение…' : 'Сохранить и отправить письмо'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
